import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { operatorImage } from "@/mocks/home";

export default function OperatorAbout() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-content px-5 py-16 md:px-6 md:py-20">
        <div className="grid items-center gap-10 lg:grid-cols-[42fr_58fr] lg:gap-14">
          <Reveal className="w-full">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-xl bg-background-200 shadow-[0_18px_40px_-26px_rgba(23,37,35,0.35)]">
              <img
                src={operatorImage}
                alt="机の上に置かれたノートパソコンとノート、窓の外に広がる大学キャンパス"
                title="留学準備 勉強机 アメリカの大学キャンパス"
                className="absolute inset-0 h-full w-full object-cover object-top"
              />
            </div>
            <p className="mt-3 flex items-center gap-1.5 text-[11.5px] text-foreground-500">
              <i className="ri-image-line text-[13px] text-primary-600" />
              ※イメージ画像です
            </p>
          </Reveal>

          <Reveal delay={80} className="w-full">
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-600">
              About
            </p>
            <h2 className="mt-3 font-heading text-[26px] font-bold tracking-tight text-foreground-950 md:text-[34px]">
              運営者について
            </h2>

            <div className="mt-6 space-y-4 text-[13px] leading-[2] text-foreground-700 md:text-[14px]">
              <p>
                はじめまして！このサイトを運営している、テキサス州のコミュニティカレッジに通う19歳の日本人大学生です。高校卒業後、留学エージェントを使わずに自分で出願してアメリカへ渡り、現在は4年制大学への編入を目指して勉強しています。
              </p>
              <p>
                このサイトでは、実際の経験をもとに、費用を抑えながらアメリカ留学を実現し、編入まで進むための情報を、わかりやすく発信しています。編入はまだ経験していない立場なので、制度の情報は公式サイトを確認しながら整理し、体験談は体験した範囲で書いています。
              </p>
            </div>

            <div className="mt-7 flex flex-wrap gap-2.5">
              {["現役コミカレ生", "エージェント未使用", "4年制大学への編入を目指して準備中"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-[11px] font-medium text-foreground-700"
                >
                  {tag}
                </span>
              ))}
            </div>

            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-700 bg-transparent px-6 py-3 text-[13px] font-semibold text-primary-800 transition-all duration-200 hover:-translate-y-[2px] hover:bg-background-50 hover:shadow-[0_12px_24px_-18px_rgba(23,37,35,0.5)]"
            >
              詳しいプロフィールを見る
              <i className="ri-arrow-right-line text-[14px]" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}